export default "__VITE_ASSET__5_Lb8xSi__"